import { useCreateAccountProvider } from '@/lib/context';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { STATIC_FILE_URL } from '@/shared/constants';
import React from 'react';
import Image from 'next/image';
import s3ImageTransform from '@/shared/utils/s3ImageTransform';
import { getCreatorHubSourcingHomePath } from '@/shared/utils/sourcing-marketplace-util';
import { SUBMIT_RFP_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import './index.less';

function CustomProjectPage() {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  const onRFPButtonClick = () => {
    logCommonView(EventSource.RFP_STARTED, 'browse-suppliers-rfp-tab');
    showSignupDialogFromSourcing(SUBMIT_RFP_DESCRIPTION, getCreatorHubSourcingHomePath(), 'rfp');
  };

  return (
    <div className="custom-project-page">
      <div className="container">
        <div className="left">
          <div className="header">
            <h2 className="title">Submit a custom project request</h2>
            <span className="subtitle">
              Submit a project and have multiple suppliers reach out within 48 hours with responses.
            </span>
          </div>
          <div className="stats">
            <div className="stat">
              <span className="figure">10,000+</span>
              <span className="label">Projects posted</span>
            </div>
            <div className="stat">
              <span className="figure">1,300+</span>
              <span className="label">Vetted suppliers</span>
            </div>
            <div className="stat">
              <span className="figure">{'< 48h'}</span>
              <span className="label">Avg response time</span>
            </div>
          </div>
          <div className="rfp-button" onClick={onRFPButtonClick}>
            Create a custom project
          </div>
        </div>
        <div className="right">
          <div className="social-proof">
            <div className="top">
              <Image
                width={34}
                height={34}
                className="avatar"
                src={s3ImageTransform(`${STATIC_FILE_URL}/387caf05c64d584f5b755dfce875aea3.png`, 'compact')}
                alt="avatar"
              />
              <div className="person">
                <span className="name">Taylor</span>
                <span className="occupation">Nurse Workwear</span>
              </div>
            </div>
            <span className="quote">
              &quot;&#34;My first product went live early this morning and just made my first sale. Pietra helped with
              getting everything up and running quickly and smoothly. This is such an amazing platform for custom
              products, I wouldn&#39;t know where to start without it&quot;&#34;
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomProjectPage;
